var AUTOGENERATED_CONTENT_SECTIONS, RICH_FORMAT_FIELDS, etdHelper, getCellContent, getGrouppedTagsFromQuestion, getInValue, getQuestionAttrContent, getQuestionAttrName, getQuestionData, getSectionValue, getValue, hasAutoContentGenerationOn, isAutoContentCell, isDxQuestionWithoutComparatorTest, utils,
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

getGrouppedTagsFromQuestion = require('lib/question_tags_helper').getGrouppedTagsFromQuestion;

etdHelper = require('lib/etd_helper');

utils = require('base/lib/utils');

AUTOGENERATED_CONTENT_SECTIONS = ['intent', 'age', 'population', 'option', 'intervention', 'comparison', 'mainOutcomes', 'setting'];

RICH_FORMAT_FIELDS = ['mainOutcomes', 'anticipatedOutcomes', 'background', 'coi'];

getValue = function(data, key, defaultValue) {
  if (defaultValue == null) {
    defaultValue = '';
  }
  if ((data != null ? data.get : void 0) != null) {
    return data.get(key, defaultValue);
  } else {
    return _.get(data, key, defaultValue);
  }
};

getInValue = function(data, path, defaultValue) {
  if ((data != null ? data.getIn : void 0) != null) {
    return data.getIn(path, defaultValue);
  } else {
    return _.get(data, path.join('.'), defaultValue);
  }
};

getSectionValue = function(sections, sectionId, key, defaultValue) {
  if ((sections != null ? sections.getIn : void 0) != null) {
    return sections.getIn([sectionId, key], defaultValue);
  } else {
    return _.get(sections, "" + sectionId + "." + key, defaultValue);
  }
};

getQuestionAttrName = function(sectionId) {
  var header2questionAttrMap, _ref;
  header2questionAttrMap = {
    'population': 'healthProblemOrPopulation',
    'setting': 'settings',
    'author': 'authors',
    'intervention_tx': 'intervention',
    'option': 'intervention',
    'comparison_tx': 'comparison',
    'intervention_dx': 'indexTest',
    'comparison_dx': 'comparatorTest'
  };
  return (_ref = header2questionAttrMap[sectionId]) != null ? _ref : sectionId;
};

getQuestionData = function(_arg) {
  var keyMessagesData, overarchingQuestionData, type;
  type = _arg.type, overarchingQuestionData = _arg.overarchingQuestionData, keyMessagesData = _arg.keyMessagesData;
  switch (type) {
    case 'overarching':
      return overarchingQuestionData;
    case 'keyMessages':
      return keyMessagesData;
  }
};

getQuestionAttrContent = function(_arg) {
  var content, keyMessagesData, overarchingQuestionData, placeholderString, question, questionAttrName, questionData, questionType, sectionId, type, typedSectionId;
  keyMessagesData = _arg.keyMessagesData, overarchingQuestionData = _arg.overarchingQuestionData, question = _arg.question, questionType = _arg.questionType, sectionId = _arg.sectionId, type = _arg.type;
  if (type === 'overarching' || type === 'keyMessages') {
    questionData = getQuestionData({
      type: type,
      overarchingQuestionData: overarchingQuestionData,
      keyMessagesData: keyMessagesData
    });
    switch (sectionId) {
      case 'mainOutcomes':
      case 'outcomes':
        return etdHelper.getTagsString('outcome', getGrouppedTagsFromQuestion(questionData));
      case 'age':
        return etdHelper.getAgeString(getInValue(questionData, ['metadata', 'age'], Immutable.List()));
      case 'intent':
        return etdHelper.getIntentString(getInValue(questionData, ['metadata', 'intent'], Immutable.List()));
      case 'population':
      case 'intervention':
      case 'comparison':
        return etdHelper.getTagsString(sectionId, getGrouppedTagsFromQuestion(questionData));
      case 'setting':
      case 'author':
      case 'background':
      case 'perspective':
      case 'coi':
        return getValue(questionData, sectionId, '');
      default:
        return '';
    }
  } else {
    switch (sectionId) {
      case 'mainOutcomes':
        return etdHelper.getOutcomesString(question);
      case 'intervention':
      case 'comparison':
        typedSectionId = "" + sectionId + "_" + questionType;
        questionAttrName = getQuestionAttrName(typedSectionId);
        content = getValue(question, questionAttrName);
        placeholderString = utils.bracketize($.t('es:question.comparator_test'));
        if (content === placeholderString) {
          return '';
        } else {
          return content;
        }
        break;
      case 'population':
      case 'setting':
      case 'option':
      case 'author':
      case 'authors':
      case 'background':
        questionAttrName = getQuestionAttrName(sectionId);
        return getValue(question, questionAttrName);
      default:
        return '';
    }
  }
};

isAutoContentCell = function(sectionId) {
  return __indexOf.call(AUTOGENERATED_CONTENT_SECTIONS, sectionId) >= 0;
};

hasAutoContentGenerationOn = function(_arg) {
  var headerSections, sectionId, type;
  headerSections = _arg.headerSections, sectionId = _arg.sectionId, type = _arg.type;
  if (type === 'overarching') {
    return true;
  }
  if (isAutoContentCell(sectionId)) {
    return getSectionValue(headerSections, sectionId, 'autoContentGenerationOn', true);
  }
};

getCellContent = function(_arg) {
  var defaultContent, headerSections, keyMessagesData, overarchingQuestionData, question, questionType, sectionId, type;
  headerSections = _arg.headerSections, keyMessagesData = _arg.keyMessagesData, overarchingQuestionData = _arg.overarchingQuestionData, question = _arg.question, questionType = _arg.questionType, sectionId = _arg.sectionId, type = _arg.type;
  defaultContent = getQuestionAttrContent({
    keyMessagesData: keyMessagesData,
    overarchingQuestionData: overarchingQuestionData,
    question: question,
    questionType: questionType,
    sectionId: sectionId,
    type: type
  });
  if (hasAutoContentGenerationOn({
    headerSections: headerSections,
    sectionId: sectionId,
    type: type
  })) {
    return defaultContent;
  } else {
    return getSectionValue(headerSections, sectionId, 'content');
  }
};

isDxQuestionWithoutComparatorTest = function(_arg) {
  var question, questionType;
  question = _arg.question, questionType = _arg.questionType;
  return questionType === 'dx' && !getValue(question, 'comparatorTestPresent');
};

module.exports = {
  AUTOGENERATED_CONTENT_SECTIONS: AUTOGENERATED_CONTENT_SECTIONS,
  RICH_FORMAT_FIELDS: RICH_FORMAT_FIELDS,
  getCellContent: getCellContent,
  getQuestionAttrContent: getQuestionAttrContent,
  getQuestionAttrName: getQuestionAttrName,
  hasAutoContentGenerationOn: hasAutoContentGenerationOn,
  isAutoContentCell: isAutoContentCell,
  isDxQuestionWithoutComparatorTest: isDxQuestionWithoutComparatorTest
};
